import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import Vue from 'vue'

Vue.component('vue-simple-context-menu', VueSimpleContextMenu)
